import { render } from "./Create.vue?vue&type=template&id=0aee58f7&lang=pug"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render

export default script